<template>
  <v-app>
    <v-main >
            <Toaster  position="top-right" :expand="true" :visibleToasts="9" richColors closeButton :enableHtml='true' />
      <!-- <CustomSidebar />
      <TopBar />
      <router-view/> -->
      <Teleport to="body">
        <CustomSidebar v-if='isAuth' />
      </Teleport>
      <div class="container-fluid main_container" >
        <div class="row">
          <div :class="isAuth ? 'col-12 mainContentWithSidebar': 'col-12' " id="mainContent">
            <TopBar v-if='isAuth'/>
            <router-view :key="$route.fullPath" />
            <div id="footer"  v-if='isAuth'>
                  <div>
                    <img :src="require('@/assets/images/logo-simple.png')"  class="sidebar_logo_extra_small" alt="">
                    <div class="linksfootertermspolicy">
                        <a href="/datapolicy">Data policy</a>
                        <a href="/terms_and_conditions">Terms and conditions</a>
                        <span><a href="https://innopearl.ch" target="_blank">Innopearl © {{new Date().getFullYear() }}</a></span>
                    </div>
                  </div>
              
            </div>
          </div>
        </div>
      </div>


    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import CustomSidebar from '@/components/sidebar/CustomSidebar.vue';
import TopBar from '@/components/sidebar/TopBar.vue';
import { Toaster } from 'vue-sonner'
export default {
  name: 'App',
  components: {
    CustomSidebar,
    TopBar,
    Toaster
  },
  data: () => ({
    //
  }),
  mounted(){
      this.$store.commit('INITIALISESTORE')
  },
  computed: mapState(['isAuth']),
  watch: {
    '$route' (to) {
      document.title = to.name || 'Partner+ Club'
    },
  },
}
</script>

<style media="screen">

@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');
@import url('https://api.fontshare.com/v2/css?f[]=satoshi@400,500,700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600;700&display=swap');
@import url('@/assets/css/candidate-card.css');
@import url('@/assets/css/modal.css');
@import url('@/assets/css/filter-panel.css');
@import url('@/assets/css/list-page.css');
@import url('@/assets/css/search-input.css');
@import url('@/assets/css/section-title.css');
@import url('@/assets/css/count-badge.css');
@import url('@/assets/css/data-tooltip.css');
@import url('@/assets/css/ai-loader.css');
@import url('@/assets/css/form-inputs.css');
@import url('@/assets/css/filter-toggler.css');
@import url('@/assets/css/action-bar-pill.css');
@import url('@/assets/css/icon-buttons.css');
@import url('@/assets/css/assessment-criteria.css');
@import url('@/assets/css/startup-profile.css');

:root{
  /* Charte graphique Innopearl Partner+ */
  --color-white: #F2F2F0;
  --color-gold: #D5A029;
  --color-dark-blue: #133967;
  --color-light-blue: #3981C3;
  --color-purple: #8679B7;
  --color-bg: #FFF;

  /* Couleurs neutres / texte */
  --color-text-muted: #94A3B8;
  --color-border: #E6ECF2;
  --color-border-soft: rgba(213, 214, 214, 0.5);
  --color-bg-hover-blue: #F1F7FF;

  /* Statuts */
  --color-status-inprogress: #FFAA2A;
  --color-status-completed: #4ADE80;
  --color-status-draft: #6C68A2;
  --color-status-closed: #ADB3B5;
  --color-status-error: #F44A5F;
  --color-status-warning: #FFB802;
  /* Pastel variants for status pills (used across all list/detail pages) */
  --color-status-inprogress-bg: rgba(255, 170, 42, 0.18);
  --color-status-completed-bg:  rgba(74, 222, 128, 0.18);
  --color-status-draft-bg:      #8679B7;
  --color-status-closed-bg:     rgba(173, 179, 181, 0.22);

  /* Fonds alertes */
  --color-bg-info: #E9F1F8;
  --color-bg-warning: #FFF4DE;
  --color-bg-success: #E7FFEF;

  /* Gradients */
  --gradient-blue-vertical: linear-gradient(180deg, #253571 0%, #3981C3 100%);
  --gradient-blue-vertical-reverse: linear-gradient(180deg, #3981C3 0%, #253571 100%);
  --gradient-blue-horizontal: linear-gradient(270deg, #3981C3 0%, #1368B2 100%);
  --gradient-blue-diagonal: linear-gradient(105deg, #1D2091 0%, #3981C3 100%);
  --gradient-blue: var(--gradient-blue-vertical);

  /* Radius (intents) */
  --radius-pill: 999px;
  --radius-xl: 24px;
  --radius-lg: 16px;
  --radius-md: 12px;
  --radius-sm: 10px;
  --radius-xs: 6px;

  /* Shadows */
  --shadow-sm: 0px 3px 6px #00000029;
  --shadow-card: 0 12px 32px rgba(19, 57, 103, 0.08);
  --shadow-card-hover: 0 18px 40px rgba(19, 57, 103, 0.10);
  --shadow-focus: 0 0 0 3px rgba(57, 129, 195, 0.10);
  --shadow-focus-dark: 0 0 0 3px rgba(19, 57, 103, 0.12);
  --shadow-modal: 0 24px 60px rgba(19, 57, 103, 0.18);

  /* Transitions */
  --transition-fast: 0.15s ease;
  --transition-base: 0.2s ease;
  --transition-slow: 0.3s ease;

  /* Layout */
  --page-padding: 50px;

  /* Typographie */
  --font-title: 'Satoshi', sans-serif;
  --font-body: 'Open Sans', sans-serif;

  /* Tailles */
  --font-size-page-title: 28px;
  --font-size-main-title: 24px;
  --font-size-section: 20px;
  --font-size-card: 16px;
  --font-size-lg: 18px;
  --font-size-body: 14px;
  --font-size-small: 13px;
  --font-size-xsmall: 12px;
}

/* Default text color — charte: Open Sans dark blue.
   Set on the root only, so descendants inherit by default but
   explicit color overrides (e.g. white on gradient headers) keep working. */
html,
body,
#app{
  font-family: var(--font-body);
  color: var(--color-dark-blue);
}

/* Action buttons — design system */
.primary-action-button,
.secondary-action-button,
.alternative-action-button {
  height: 38px;
  padding: 0 20px;
  border-radius: var(--radius-sm);
  font-family: var(--font-body);
  font-size: var(--font-size-lg);
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-decoration: none;
  white-space: nowrap;
  transition: opacity var(--transition-base), transform 0.1s ease, background 0.2s ease, color 0.2s ease;
  border: 2px solid transparent;
  box-sizing: border-box;
}
.primary-action-button:hover:not(:disabled) {
  opacity: 0.85;
}
.primary-action-button:active,
.secondary-action-button:active,
.alternative-action-button:active {
  transform: scale(0.97);
}
.primary-action-button:disabled,
.secondary-action-button:disabled,
.alternative-action-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.primary-action-button,
.primary-action-button:hover,
.primary-action-button:focus,
.primary-action-button:visited {
  background: var(--color-dark-blue) !important;
  color: #FFFFFF !important;
  border-color: var(--color-dark-blue) !important;
}
.secondary-action-button,
.secondary-action-button:hover,
.secondary-action-button:focus,
.secondary-action-button:visited {
  background: var(--color-gold) !important;
  color: var(--color-dark-blue) !important;
  border-color: var(--color-gold) !important;
  opacity: 1 !important;
  transition: filter 0.15s ease, background 0.15s ease;
}
.secondary-action-button:hover:not(:disabled),
.secondary-action-button:active{
  filter: brightness(1.05) !important;
}
.alternative-action-button,
.alternative-action-button:focus,
.alternative-action-button:visited {
  background: #FFFFFF !important;
  color: var(--color-dark-blue) !important;
  border-color: var(--color-dark-blue) !important;
}
.alternative-action-button:hover:not(:disabled) {
  background: var(--color-dark-blue) !important;
  color: #FFFFFF !important;
}

/* Modal close button (X) — white bg, dark blue icon */
.v-dialog .close,
.v-overlay__content .close{
  position: absolute !important;
  right: 12px !important;
  top: 12px !important;
  width: 36px !important;
  height: 36px !important;
  padding: 0 !important;
  border-radius: 50% !important;
  background: #FFFFFF !important;
  color: var(--color-dark-blue) !important;
  border: 1px solid rgba(19, 57, 103, 0.12) !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-family: var(--font-title) !important;
  font-weight: 700 !important;
  font-size: var(--font-size-card) !important;
  line-height: 1 !important;
  cursor: pointer !important;
  box-shadow: 0 2px 6px rgba(19, 57, 103, 0.08) !important;
  transition: background var(--transition-base), color 0.2s ease !important;
}
.v-dialog .close:hover,
.v-overlay__content .close:hover{
  background: var(--color-dark-blue) !important;
  color: #FFFFFF !important;
}
.v-dialog .close .v-icon,
.v-overlay__content .close .v-icon{
  color: inherit !important;
}

/* Back button — shared style (apply to <button> or <a>) */
.back-btn,
.back-btn:hover,
.back-btn:focus,
.back-btn:visited{
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  width: fit-content;
  max-width: max-content;
  gap: 12px;
  height: 36px;
  padding: 0 12px;
  background: transparent !important;
  border: none !important;
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-family: var(--font-title);
  font-weight: 500;
  font-size: var(--font-size-card);
  color: var(--color-dark-blue) !important;
  letter-spacing: -0.01em;
  text-decoration: none;
  transition: background-color var(--transition-base);
}
.back-btn:hover:not(:disabled){
  background: rgba(19, 57, 103, 0.05) !important;
}
.back-btn:disabled{
  opacity: 0.4;
  cursor: not-allowed;
}
.back-btn .back-btn__icon{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--color-gold);
}

.linksfootertermspolicy{
  display:flex;
  gap:10px;
  justify-content: center;
}
.linksfootertermspolicy a,
.linksfootertermspolicy a:hover{
  color: var(--color-dark-blue) !important;

}
*{
    font-family: var(--font-body) !important;
}

/* === Global page max-width — single source of truth === */
:root{
  --page-max-width: 1200px;
}
.page_max_width{
  max-width: var(--page-max-width);
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

/* === Quill editor default text color (Innopearl charte) === */
.ql-editor,
.ql-editor p,
.ql-editor li,
.ql-editor h1,
.ql-editor h2,
.ql-editor h3,
.ql-editor h4,
.ql-editor h5,
.ql-editor h6,
.ql-editor span:not([style*="color"]){
  color: var(--color-dark-blue);
}
/* === Quill editor : 2 cartes distinctes, toolbar et container avec bordure complète === */
body .ql-snow.ql-toolbar,
body .ql-toolbar.ql-snow{
  border: 1px solid var(--color-border-soft) !important;
  border-radius: var(--radius-md) !important;
  background: #FFFFFF !important;
  margin: 0 0 3px 0 !important;
}
body .ql-snow.ql-container,
body .ql-container.ql-snow{
  border: 1px solid var(--color-border-soft) !important;
  border-radius: var(--radius-md) !important;
  background: #FFFFFF !important;
  margin: 0 !important;
}
body .ql-snow .ql-picker.ql-expanded .ql-picker-label{
  border-color: var(--color-border-soft) !important;
}

/* === Status pills — pastel bg + dark-blue text, app-wide === */
.status.inprogress,
.status.draft,
.status.completed,
.status.closed,
.ranking_status.inprogress,
.ranking_status.draft,
.ranking_status.completed,
.ranking_status.closed,
.status_badge.valid,
.status_badge.expired{
    color: var(--color-dark-blue) !important;
    letter-spacing: 0.02em;
}
.status.inprogress,
.ranking_status.inprogress{ background: var(--color-status-inprogress-bg) !important; }
.status.draft,
.ranking_status.draft{       background: var(--color-status-draft-bg) !important; }
.status.completed,
.ranking_status.completed,
.status_badge.valid{         background: var(--color-status-completed-bg) !important; }
.status.closed,
.ranking_status.closed{      background: var(--color-status-closed-bg) !important; }
.status_badge.expired{       background: var(--color-status-inprogress-bg) !important; }
.status.draft,
.ranking_status.draft,
.status.draft .status-text,
.ranking_status.draft .status-text{
    color: #FFFFFF !important;
}
.status .status-text{
    color: var(--color-dark-blue) !important;
    font-weight: 700 !important;
}
.status.draft .status-text{
    color: #FFFFFF !important;
}

/* Titres : Satoshi pour h1–h6 + toute classe contenant "title" / "Title" */
h1, h2, h3, h4, h5, h6,
[class*="title"], [class*="Title"] {
    font-family: var(--font-title) !important;
}
  #content{
    /* margin-left: 15%; */
    background : var(--color-bg);
    min-height: calc(100vh);
    padding: var(--page-padding) var(--page-padding) 50px var(--page-padding);
  }

  /* Global override: no border / shadow / radius on .content_div wrappers */
  .content_div,
  .content_div.stats,
  .content_div.brief_view_wrapper,
  .brief_view_card{
    border: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
  }

  .main_container > .row > .col{
    padding: 0px !important;
    margin: 0px !important;
  }
  .main_container{
    padding-left: 0 !important;
    padding-right: 0 !important;
    max-width: none !important;
  }
  .main_container > .row{
    margin-left: 0 !important;
    margin-right: 0 !important;
    --bs-gutter-x: 0 !important;
  }
  .mainContentWithSidebar{
    margin-left: 240px !important;
    width: calc(100vw - 240px) !important;
    max-width: calc(100vw - 240px) !important;
    flex: 0 0 auto !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    overflow-x: clip;
    box-sizing: border-box;
  }
  body,
  html,
  #app,
  .v-application,
  .v-application__wrap,
  .v-main,
  .v-main__wrap{
    background: #FFFFFF !important;
  }
  body{
    margin: 0 !important;
    background: #FFFFFF !important;
  }
  @media screen and (max-width: 1200px){
    .mainContentWithSidebar{
      margin-left: 60px !important;
      width: calc(100vw - 60px) !important;
      max-width: calc(100vw - 60px) !important;
    }
  }

  .prev_step_btn,
  .next_step_btn,
  .contact_step_btn{
      display:inline-block;
  }

  /* Unified next_step_btn — dark blue filled, matches charte */
  .next_step_btn,
  .next_step_btn:hover,
  .next_step_btn:focus,
  .next_step_btn:visited{
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 38px;
    padding: 0 20px !important;
    background: var(--color-dark-blue) !important;
    color: #FFFFFF !important;
    border: 2px solid var(--color-dark-blue) !important;
    border-radius: var(--radius-sm) !important;
    font-family: var(--font-body);
    font-weight: 700;
    font-size: var(--font-size-body);
    line-height: 1;
    letter-spacing: 0;
    text-transform: none;
    text-decoration: none;
    box-shadow: none !important;
    cursor: pointer;
    transition: opacity var(--transition-base);
    margin: 0;
  }
  .next_step_btn:hover:not(:disabled){
    opacity: 0.85;
  }
  .next_step_btn:disabled{
    opacity: 0.5;
    cursor: not-allowed;
  }
  .next_step_btn img,
  .next_step_btn .v-icon{
    filter: brightness(0) invert(1);
  }
  .next_step_btn .v-icon{
    filter: none;
    color: #FFFFFF !important;
  }
  .mt20{
    margin-top: 20px;
  }

  @media screen and (max-width: 1200px){
    #mainContent{
      width:100%;
    }


  }

  @media screen and (max-width: 990px){
    .prev_step_btn,
    .next_step_btn,
    .contact_step_btn{
      font-size: var(--font-size-xsmall);

  }

  button.step{
    display: flex;
flex-direction: column;

  }
  }

.v-theme--myCustomLightTheme{
        --v-disabled-opacity: 1 !important;
    }

    @media (min-width: 1400px){
    .container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {
    max-width: 90% !important;
    }

  }

  a, a:hover{
    text-decoration: none !important;
  }

  #footer{
        background : #FFF;
        padding:20px;
        text-align:center;
        font-size: var(--font-size-xsmall);
        color:#333;
  }
  #footer a{
    text-align:center;
  }

  .sidebar_logo_extra_small{
    width: 80px;
  height: 40px;
  }
  .v-btn--icon{
    border:none !important;
  }

  .footerAbs{
    position:absolute;
    bottom:20px;
    right:20px;
  }
  :focus-visible {
    outline: none !important;
  }

  .loaderInnopearl{
    display: flex;
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 20px;
  }

  .loaderInnopearlInner{
    padding: 10px 50px;
  border: 1px solid rgba(57, 129, 195, 0.251);
  border-radius: var(--radius-pill);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  color: var(--color-dark-blue);
  font-size: var(--font-size-small);
  font-weight: 600;
}
  .loaderInnopearlInner img{
    animation: rotating 3s linear infinite;
  }

  @keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.quicksearch input:-moz-placeholder{
   color: var(--color-dark-blue) !important;
   opacity:1 !important;
   font-weight: 500 !important;
   text-transform: none !important;
   font-size:var(--font-size-body);
}
.quicksearch input::placeholder{
   color: var(--color-dark-blue) !important;
   opacity:1 !important;
   font-weight: 500 !important;
   text-transform: none !important;
   font-size:var(--font-size-body);
}
.quicksearch input::-moz-placeholder{
   color: var(--color-dark-blue) !important;
   opacity:1 !important;
   font-weight: 500 !important;
   text-transform: none !important;
   font-size:var(--font-size-body);
}
.quicksearch input::-webkit-input-placeholder{
   color: var(--color-dark-blue) !important;
   opacity:1 !important;
   font-weight: 500 !important;
   text-transform: none !important;
   font-size:var(--font-size-body);
}
.quicksearch input:-ms-input-placeholder{
   color: var(--color-dark-blue) !important;
   opacity:1 !important;
   font-weight: 500 !important;
   text-transform: none !important;
   font-size:var(--font-size-body);
}
.quicksearch input::-ms-input-placeholder{
   color: var(--color-dark-blue) !important;
   opacity:1 !important;
   font-weight: 500 !important;
   text-transform: none !important;
   font-size:var(--font-size-body);
}
.v-dialog.nopaddd > .v-overlay__content > .v-card > .v-card-text{
  padding-top: 20px !important;
    padding-bottom: 20px !important;
    padding-left: 0 !important;
    padding-right: 0px !important;
}

.alert-info{
  background: var(--color-bg-info) !important;
  border: 1px solid rgba(55, 131, 197, .15) !important;
  color: var(--color-dark-blue) !important;
  font-weight: 500 !important;
  display: flex !important;
  gap: 20px !important;
  align-items: center;

}
.alert-info::before{
  content:url('notif.svg');
}

.alert-warning{
  background: #FFF4DE !important;
  border: 1px solid rgba(255, 170, 42, .15) !important;
  color: var(--color-dark-blue) !important;
  font-weight: 500 !important;
  display: flex !important;
  gap: 20px !important;
  align-items: center;

}
.alert-warning::before{
  content:url('notifWarning.svg');
}


.alert-success{
  background: #E7FFEF !important;
  border: 1px solid rgba(74, 222, 128, .15) !important;
  color: var(--color-dark-blue) !important;
  font-weight: 500 !important;
  display: flex !important;
  gap: 20px !important;
  align-items: center;

}
.alert-success::before{
  content:url('notifSuccess.svg');
}

</style>
